import { forwardRef } from 'react'
import { Select } from 'tea-component'

const NSelect = (props: any, ref: any) => {
    const { field, ...rest } = props
    return <Select ref={ref} {...rest}/>
}
export default forwardRef(NSelect)
